<template>
  <div class="basis-50 h-[100vh]" style="background-color: rgb(33 45 51);">
    <div class="flex text-2xl text-white py-5 border-b border-b-cyan-900">
<!--      <div class="pl-5 pt-1 text-emerald-400">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
        </svg>
      </div>-->
      <span class="w-full center">AppLog</span>
    </div>
    <div class="pb-10 border-b border-b-cyan-900">
      <LeftMenu/>
    </div>
<!--    <div class="">
      <a @click.prevent="logout" class="block mt-2">
        <div class="flex py-4 pl-10">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
          </svg>
          <span class="pl-2">Выйти</span>
        </div>
      </a>
    </div>-->
  </div>
</template>

<script>
import store from '@/store.js'
import LeftMenu from "@/components/LeftMenu.vue"

export default {
  name: 'LeftSide',
  components: {LeftMenu},
  data() {
    return {
      store
    }
  },
  methods: {
    logout: function () {
      this.store.commit('unauthorize')
    }
  }
}
</script>

<style scoped>

</style>